<p-dialog
  [(visible)]="isLoading"
  [closable]="true"
  [closeOnEscape]="true"
  [contentStyle]="{
    display: 'flex',
    'justify-content': 'center',
    'align-items': 'center',
    height: '100%',
    background: 'transparent',
    'box-shadow': 'none',
  }"
  [dismissableMask]="false"
  [draggable]="false"
  [modal]="true"
  [resizable]="false"
  [showHeader]="false"
  [style]="{
    width: '100vw',
    height: '100vh',
    background: 'transparent',
    border: 'none',
  }"
>
  <p-progressSpinner></p-progressSpinner>
</p-dialog>
